import React from 'react';
import {
  isAllowedThroughLinkAccess,
  PostPolicyAction,
} from './postPolicyCheck';
import type { PostStateBarComponentProps } from './PostStateBar';
import PostViewStateBar from './PostViewStateBar';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import Tooltip from '../components/Tooltip';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import publicIcon from '../icons/non-prefilled/16x16/public.svg';
import templateIcon from '../icons/non-prefilled/16x16/template.svg';
import { UserRole } from '../topic/topicPolicyCheck';
import { createPostPath } from '../utils/url/postPath';

const POST_FRAGMENT = gql(`
  fragment PostTemplateBar_post on Post {
    id
    ...isAllowedThroughLinkAccess_post
  }
`);

interface PostTemplateBarProps extends PostStateBarComponentProps {
  post: DocumentType<typeof POST_FRAGMENT>;
}

const PostTemplateBar = ({ post, compact }: PostTemplateBarProps) => {
  const isPublic = isAllowedThroughLinkAccess(
    PostPolicyAction.ViewPost,
    post,
    UserRole.Anonymous,
  );

  return (
    <PostViewStateBar
      actions={
        <Button
          variant="primary"
          to={createPostPath({ templateId: post.id })}
          size="small"
        >
          Create post
        </Button>
      }
    >
      <SVGIcon>{templateIcon}</SVGIcon>
      <strong>Template</strong>
      {!compact && <span>Create new posts from this template’s contents</span>}
      {isPublic && (
        <Tooltip
          trigger="clickOrHover"
          content={
            'Logged out visitors\ncan access this template\nwith its URL'
          }
          placement="bottom"
        >
          <SVGIcon>{publicIcon}</SVGIcon>
        </Tooltip>
      )}
    </PostViewStateBar>
  );
};

export default PostTemplateBar;
